module.exports = __webpack_public_path__ + "static/media/40-12.dd108d6c.mp3";